/**
 * Minifigs 2.0 - Cart torso text overlay
 * https://www.npmjs.com/package/textfit
 *
 * @author Matt Haynes <matthew.haynes@joipolloi.com>
 * @package Joi Polloi
 */

import textFit from "textfit";

const cartTorsoTextOverlay = () => {
    const cart = document.querySelector('.cart__contents');
    if (!cart) return;
    const textOvlerays = document.querySelectorAll('.cart-item__overlaytext .inner');
    const options = {
        minFontSize: 5,
        maxFontSize: 50
    };

    textOvlerays.forEach(textOverlay => {
        textFit(textOverlay, options);
    });
};

export default cartTorsoTextOverlay;
export { cartTorsoTextOverlay as torsoMediaOverlays };
